var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnacks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_303068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 318C416.7 333.2 416.7 357.9 431.9 373L500 441.1V500H0V206.7C14.4 213.5 32.1 210.9 44 199L243 0H359L500 141.1V250L431.9 318Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.8 171.3C335.6 178.3 297.3 191.1 294.8 187.9C292.3 184.7 297.7 151 297.7 151C297.7 151 299.2 151.5 301.7 152.3C310.6 155.3 331.6 162.7 336.7 168.4C337.6 169.4 338 170.4 337.8 171.3Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7 168.4C325.1 175 302.1 182 300.2 179.5C298.6 177.4 300.3 162.5 301.7 152.3C310.6 155.3 331.6 162.8 336.7 168.4Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.1 109.3C245.7 109.9 215.8 74.5 218.2 70.5C220.6 66.5 258.7 58 258.7 58C258.7 58 258.8 59.8 259 62.8C259.6 73.5 260.6 99.1 256.7 107C256 108.4 255.2 109.3 254.1 109.3Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7 107C244.8 97.3999 227.6 75.7999 229.4 72.7999C230.9 70.1999 247.6 65.6999 259 62.8999C259.7 73.5999 260.6 99.1999 256.7 107Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.5 147.1C236.1 143.4 228.7 117.6 233.2 114.5C236.7 112.1 265.4 118 277.5 120.6C280.4 121.2 283.5 124 282.4 126.8L281.3 130C276.9 141.9 265.5 167.1 257.6 173.6C256.2 174.8 246.6 147.6 245.5 147.1Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7 179.3C244.4 175.6 228.8 122.4 233.2 119.3C236.7 116.9 265.2 122.7 277.3 125.4C280.2 126 281.8 129 280.8 131.8V131.9C276.4 143.7 265.4 171.7 257.6 178.1C256.2 179.3 254.9 179.8 253.7 179.3Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 139C250.364 139 252.2 137.164 252.2 134.9C252.2 132.636 250.364 130.8 248.1 130.8C245.836 130.8 244 132.636 244 134.9C244 137.164 245.836 139 248.1 139Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3 156.4C261.564 156.4 263.4 154.564 263.4 152.3C263.4 150.036 261.564 148.2 259.3 148.2C257.036 148.2 255.2 150.036 255.2 152.3C255.2 154.564 257.036 156.4 259.3 156.4Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 140.9C263.905 140.9 264.8 140.004 264.8 138.9C264.8 137.795 263.905 136.9 262.8 136.9C261.695 136.9 260.8 137.795 260.8 138.9C260.8 140.004 261.695 140.9 262.8 140.9Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.7 223.5C278.7 223.5 281.7 210.2 265.4 196.9C249.1 183.7 226.8 195.9 215.1 190.9C203.4 185.9 268.1 250.9 278.7 223.5Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6 170.9C213.6 170.9 226.1 165.3 242.3 178.5C258.6 191.7 251.1 216.1 258.4 226.5C265.7 236.9 188.9 186.9 213.6 170.9Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.6 175.9C388.6 175.9 376.2 166.2 356.8 168.7C337.4 171.2 341.5 192.6 332.2 197.1C322.9 201.6 412.4 198.7 388.6 175.9Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 193.1C326.5 193.1 325.9 186.4 337.4 184.9C348.9 183.4 366.2 193.2 374 194.1C382 195 330.7 208 326.5 193.1Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.1 156C341.1 156 346.5 148 339.3 135.2C332.1 122.3 314.3 124.6 307.9 118.3C301.5 111.9 327 171.2 341.1 156Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6 83.7001C306.6 83.7001 320.3 83.0001 330.5 101.3C340.8 119.6 324.9 139.5 327.8 151.9C330.8 164.3 277.8 89.5001 306.6 83.7001Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.3 212.3C321.3 212.3 282.3 210.3 285.2 229.2C288.1 248.1 292.7 247.2 302.9 244C313.1 240.8 344.9 237 338.5 223C332 208.9 321.3 212.3 321.3 212.3Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2 226C326.305 226 327.2 225.105 327.2 224C327.2 222.895 326.305 222 325.2 222C324.095 222 323.2 222.895 323.2 224C323.2 225.105 324.095 226 325.2 226Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 225.9C308.77 225.9 309.8 224.87 309.8 223.6C309.8 222.33 308.77 221.3 307.5 221.3C306.23 221.3 305.2 222.33 305.2 223.6C305.2 224.87 306.23 225.9 307.5 225.9Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.3 237.3C297.349 237.3 298.2 236.449 298.2 235.4C298.2 234.351 297.349 233.5 296.3 233.5C295.251 233.5 294.4 234.351 294.4 235.4C294.4 236.449 295.251 237.3 296.3 237.3Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.6 221C195.6 221 199.3 259.9 217.5 254.3C235.7 248.7 234.2 244.3 229.6 234.6C224.9 225 216.6 194.1 203.7 202.4C190.8 210.8 195.6 221 195.6 221Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6 217.4C207.705 217.4 208.6 216.504 208.6 215.4C208.6 214.295 207.705 213.4 206.6 213.4C205.495 213.4 204.6 214.295 204.6 215.4C204.6 216.504 205.495 217.4 206.6 217.4Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9 235.3C210.17 235.3 211.2 234.27 211.2 233C211.2 231.73 210.17 230.7 208.9 230.7C207.63 230.7 206.6 231.73 206.6 233C206.6 234.27 207.63 235.3 208.9 235.3Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 244.3C223.249 244.3 224.1 243.449 224.1 242.4C224.1 241.351 223.249 240.5 222.2 240.5C221.151 240.5 220.3 241.351 220.3 242.4C220.3 243.449 221.151 244.3 222.2 244.3Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.2 73.0999C350.2 73.0999 342.4 53.0999 333.6 58.7999C324.8 64.4999 326.3 66.5999 330.2 70.9999C334.1 75.3999 343.1 90.4999 348.7 84.0999C354.3 77.6999 350.2 73.0999 350.2 73.0999Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.2 78.7C345.808 78.7 346.3 78.2075 346.3 77.6C346.3 76.9925 345.808 76.5 345.2 76.5C344.593 76.5 344.1 76.9925 344.1 77.6C344.1 78.2075 344.593 78.7 345.2 78.7Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4 69.9999C342.118 69.9999 342.7 69.4179 342.7 68.6999C342.7 67.9819 342.118 67.3999 341.4 67.3999C340.682 67.3999 340.1 67.9819 340.1 68.6999C340.1 69.4179 340.682 69.9999 341.4 69.9999Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 66.7C333.552 66.7 334 66.2522 334 65.7C334 65.1477 333.552 64.7 333 64.7C332.448 64.7 332 65.1477 332 65.7C332 66.2522 332.448 66.7 333 66.7Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.1 127.8C405.1 127.8 387.7 87.5001 370.2 99.8001C352.7 112.1 355.8 116.3 364.1 125C372.4 133.7 392 163.9 402.9 150.4C413.8 137 405.1 127.8 405.1 127.8Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3 139.8C396.57 139.8 397.6 138.77 397.6 137.5C397.6 136.23 396.57 135.2 395.3 135.2C394.03 135.2 393 136.23 393 137.5C393 138.77 394.03 139.8 395.3 139.8Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8 122.1C388.236 122.1 389.4 120.936 389.4 119.5C389.4 118.064 388.236 116.9 386.8 116.9C385.364 116.9 384.2 118.064 384.2 119.5C384.2 120.936 385.364 122.1 386.8 122.1Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3 116.2C370.46 116.2 371.4 115.26 371.4 114.1C371.4 112.94 370.46 112 369.3 112C368.14 112 367.2 112.94 367.2 114.1C367.2 115.26 368.14 116.2 369.3 116.2Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295 146.4C299.142 146.4 302.5 143.042 302.5 138.9C302.5 134.758 299.142 131.4 295 131.4C290.858 131.4 287.5 134.758 287.5 138.9C287.5 143.042 290.858 146.4 295 146.4Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295 222.9C299.142 222.9 302.5 219.542 302.5 215.4C302.5 211.258 299.142 207.9 295 207.9C290.858 207.9 287.5 211.258 287.5 215.4C287.5 219.542 290.858 222.9 295 222.9Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.2 159.7C217.551 159.7 222.7 154.551 222.7 148.2C222.7 141.849 217.551 136.7 211.2 136.7C204.849 136.7 199.7 141.849 199.7 148.2C199.7 154.551 204.849 159.7 211.2 159.7Z",
    fill: "#131A46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.8 168.3C335.6 175.3 297.3 188.1 294.8 184.9C292.3 181.7 297.7 148 297.7 148C297.7 148 299.2 148.5 301.7 149.3C310.6 152.3 331.6 159.7 336.7 165.4C337.6 166.4 338 167.4 337.8 168.3Z",
    fill: "#F2A149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7 165.4C325.1 172 302.1 179 300.2 176.5C298.6 174.4 300.3 159.5 301.7 149.3C310.6 152.3 331.6 159.8 336.7 165.4Z",
    fill: "#F9E5CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1 106.3C245.7 106.9 215.8 71.5 218.2 67.5C220.6 63.5 258.7 55 258.7 55C258.7 55 258.8 56.8 259 59.8C259.6 70.5 260.6 96.1 256.7 104C256 105.4 255.2 106.3 254.1 106.3Z",
    fill: "#F2A149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7 104C244.8 94.3999 227.6 72.7999 229.4 69.7999C230.9 67.1999 247.6 62.6999 259 59.8999C259.7 70.5999 260.6 96.1999 256.7 104Z",
    fill: "#F9E5CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5 144.1C236.1 140.4 228.7 114.6 233.2 111.5C236.7 109.1 265.4 115 277.5 117.6C280.4 118.2 283.5 121 282.4 123.8L281.3 127C276.9 138.9 265.5 164.1 257.6 170.6C256.2 171.8 246.6 144.6 245.5 144.1Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7 176.3C244.4 172.6 228.8 119.4 233.2 116.3C236.7 113.9 265.2 119.7 277.3 122.4C280.2 123 281.8 126 280.8 128.8V128.9C276.4 140.7 265.4 168.7 257.6 175.1C256.2 176.3 254.9 176.8 253.7 176.3Z",
    fill: "#EFE3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 136C250.364 136 252.2 134.164 252.2 131.9C252.2 129.636 250.364 127.8 248.1 127.8C245.836 127.8 244 129.636 244 131.9C244 134.164 245.836 136 248.1 136Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3 153.4C261.564 153.4 263.4 151.564 263.4 149.3C263.4 147.036 261.564 145.2 259.3 145.2C257.036 145.2 255.2 147.036 255.2 149.3C255.2 151.564 257.036 153.4 259.3 153.4Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 137.9C263.905 137.9 264.8 137.004 264.8 135.9C264.8 134.795 263.905 133.9 262.8 133.9C261.695 133.9 260.8 134.795 260.8 135.9C260.8 137.004 261.695 137.9 262.8 137.9Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7 220.5C278.7 220.5 281.7 207.2 265.4 193.9C249.1 180.7 226.8 192.9 215.1 187.9C203.4 182.9 268.1 247.9 278.7 220.5Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6 167.9C213.6 167.9 226.1 162.3 242.3 175.5C258.6 188.7 251.1 213.1 258.4 223.5C265.7 233.9 188.9 183.9 213.6 167.9Z",
    fill: "#FFECB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6 172.9C388.6 172.9 376.2 163.2 356.8 165.7C337.4 168.2 341.5 189.6 332.2 194.1C322.9 198.6 412.4 195.7 388.6 172.9Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 190.1C326.5 190.1 325.9 183.4 337.4 181.9C348.9 180.4 366.2 190.2 374 191.1C382 192 330.7 205 326.5 190.1Z",
    fill: "#FFECB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.1 153C341.1 153 346.5 145 339.3 132.2C332.1 119.3 314.3 121.6 307.9 115.3C301.5 108.9 327 168.2 341.1 153Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6 80.7001C306.6 80.7001 320.3 80.0001 330.5 98.3001C340.8 116.6 324.9 136.5 327.8 148.9C330.8 161.3 277.8 86.5001 306.6 80.7001Z",
    fill: "#FFECB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3 209.3C321.3 209.3 282.3 207.3 285.2 226.2C288.1 245.1 292.7 244.2 302.9 241C313.1 237.8 344.9 234 338.5 220C332 205.9 321.3 209.3 321.3 209.3Z",
    fill: "#FFECB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2 223C326.305 223 327.2 222.105 327.2 221C327.2 219.895 326.305 219 325.2 219C324.095 219 323.2 219.895 323.2 221C323.2 222.105 324.095 223 325.2 223Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 222.9C308.77 222.9 309.8 221.87 309.8 220.6C309.8 219.33 308.77 218.3 307.5 218.3C306.23 218.3 305.2 219.33 305.2 220.6C305.2 221.87 306.23 222.9 307.5 222.9Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.3 234.3C297.349 234.3 298.2 233.449 298.2 232.4C298.2 231.351 297.349 230.5 296.3 230.5C295.251 230.5 294.4 231.351 294.4 232.4C294.4 233.449 295.251 234.3 296.3 234.3Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6 218C195.6 218 199.3 256.9 217.5 251.3C235.7 245.7 234.2 241.3 229.6 231.6C224.9 222 216.6 191.1 203.7 199.4C190.8 207.8 195.6 218 195.6 218Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6 214.4C207.705 214.4 208.6 213.504 208.6 212.4C208.6 211.295 207.705 210.4 206.6 210.4C205.495 210.4 204.6 211.295 204.6 212.4C204.6 213.504 205.495 214.4 206.6 214.4Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9 232.3C210.17 232.3 211.2 231.27 211.2 230C211.2 228.73 210.17 227.7 208.9 227.7C207.63 227.7 206.6 228.73 206.6 230C206.6 231.27 207.63 232.3 208.9 232.3Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 241.3C223.249 241.3 224.1 240.449 224.1 239.4C224.1 238.351 223.249 237.5 222.2 237.5C221.151 237.5 220.3 238.351 220.3 239.4C220.3 240.449 221.151 241.3 222.2 241.3Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2 70.0999C350.2 70.0999 342.4 50.0999 333.6 55.7999C324.8 61.4999 326.3 63.5999 330.2 67.9999C334.1 72.3999 343.1 87.4999 348.7 81.0999C354.3 74.6999 350.2 70.0999 350.2 70.0999Z",
    fill: "#FFECB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.2 75.7C345.808 75.7 346.3 75.2075 346.3 74.6C346.3 73.9925 345.808 73.5 345.2 73.5C344.593 73.5 344.1 73.9925 344.1 74.6C344.1 75.2075 344.593 75.7 345.2 75.7Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4 66.9999C342.118 66.9999 342.7 66.4179 342.7 65.6999C342.7 64.9819 342.118 64.3999 341.4 64.3999C340.682 64.3999 340.1 64.9819 340.1 65.6999C340.1 66.4179 340.682 66.9999 341.4 66.9999Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 63.7C333.552 63.7 334 63.2522 334 62.7C334 62.1477 333.552 61.7 333 61.7C332.448 61.7 332 62.1477 332 62.7C332 63.2522 332.448 63.7 333 63.7Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1 124.8C405.1 124.8 387.7 84.5001 370.2 96.8001C352.7 109.1 355.8 113.3 364.1 122C372.4 130.7 392 160.9 402.9 147.4C413.8 134 405.1 124.8 405.1 124.8Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3 136.8C396.57 136.8 397.6 135.77 397.6 134.5C397.6 133.23 396.57 132.2 395.3 132.2C394.03 132.2 393 133.23 393 134.5C393 135.77 394.03 136.8 395.3 136.8Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8 119.1C388.236 119.1 389.4 117.936 389.4 116.5C389.4 115.064 388.236 113.9 386.8 113.9C385.364 113.9 384.2 115.064 384.2 116.5C384.2 117.936 385.364 119.1 386.8 119.1Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3 113.2C370.46 113.2 371.4 112.26 371.4 111.1C371.4 109.94 370.46 109 369.3 109C368.14 109 367.2 109.94 367.2 111.1C367.2 112.26 368.14 113.2 369.3 113.2Z",
    fill: "#F8C957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 436.1L130.8 387.1L191.2 207.4L336.3 257L274 436.1Z",
    fill: "#FB860A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4 296.8L307 284.4L295.8 291.5L291.3 279L280.2 286.1L275.7 273.7L264.5 280.8L260.1 268.4L248.9 275.4L244.4 263L233.3 270.1L228.8 257.7L217.7 264.7L213.2 252.3L202 259.4L197.6 247L186.4 254L181.7 241L182.7 240.7L186.9 252.5L198.1 245.4L202.6 257.8L213.7 250.8L218.2 263.2L229.3 256.1L233.8 268.5L245 261.4L249.5 273.9L260.6 266.8L265.1 279.2L276.2 272.1L280.7 284.6L291.9 277.5L296.3 289.9L307.5 282.8L312 295.2L322.6 288.5L323.1 289.4L311.4 296.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 368.5C247.367 368.5 262.5 353.367 262.5 334.7C262.5 316.033 247.367 300.9 228.7 300.9C210.033 300.9 194.9 316.033 194.9 334.7C194.9 353.367 210.033 368.5 228.7 368.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 354.6C226.6 354.6 224.4 354.3 222.2 353.5C211.8 349.9 206.2 338.5 209.8 328.1C210.1 327.3 210.9 326.9 211.7 327.2C212.5 327.5 212.9 328.3 212.6 329.1C209.6 338 214.3 347.6 223.2 350.7C227.5 352.2 232.1 351.9 236.2 349.9C240.3 347.9 243.3 344.4 244.8 340.1C245.1 339.3 245.9 338.9 246.7 339.2C247.5 339.5 247.9 340.3 247.6 341.1C244.8 349.4 237 354.6 228.7 354.6Z",
    fill: "#FB860A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 436.1L267.1 420.9L257.9 425.8L253.6 416.3L244.4 421.2L240.1 411.7L230.9 416.6L226.6 407.1L217.3 411.9L213 402.4L203.8 407.3L199.5 397.8L190.3 402.7L186 393.2L176.8 398.1L172.5 388.6L163.3 393.4L159 383.9L149.7 388.8L145.4 379.3L130.8 387.1L137.6 402.2L146.8 397.3L151.1 406.8L160.3 401.9L164.6 411.5L173.9 406.6L178.2 416.1L187.4 411.2L191.7 420.7L200.9 415.8L205.2 425.3L214.4 420.5L218.7 430L228 425.1L232.3 434.6L241.5 429.7L245.8 439.2L255 434.3L259.3 443.8L274 436.1Z",
    fill: "#FB860A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 143.4C299.142 143.4 302.5 140.042 302.5 135.9C302.5 131.758 299.142 128.4 295 128.4C290.858 128.4 287.5 131.758 287.5 135.9C287.5 140.042 290.858 143.4 295 143.4Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 219.9C299.142 219.9 302.5 216.542 302.5 212.4C302.5 208.258 299.142 204.9 295 204.9C290.858 204.9 287.5 208.258 287.5 212.4C287.5 216.542 290.858 219.9 295 219.9Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2 156.7C217.551 156.7 222.7 151.551 222.7 145.2C222.7 138.849 217.551 133.7 211.2 133.7C204.849 133.7 199.7 138.849 199.7 145.2C199.7 151.551 204.849 156.7 211.2 156.7Z",
    fill: "#FF595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4 405.9C220.6 432.8 131.2 386.4 89.4 319.7C76.2 297.9 67.3 270.6 75.3 245.4C83.8 217.5 111.3 201.8 137.7 194.3C146.2 191.9 154.8 190.1 163.5 188.7C165.3 188.5 165.9 191.1 164 191.6C155.5 193.2 147 195.1 138.7 197.7C111.6 206.2 84.2 223.1 79.1 253.1C75.3 275.2 83.8 297.4 95.6 315.9C118.9 351.6 155.3 378.4 195.3 392.6C226.9 403.8 262.4 405.7 293.9 393.7C302 390.9 306.6 402.6 298.4 405.9Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.9 218.4C413.5 257.7 413.2 305.1 390.3 341.5C389 343.4 386.8 346.7 385.5 348.7C383.3 351.4 381.2 354.3 378.9 356.9C378 357.8 373.3 363 372.5 363.8C370.2 365.9 367.2 368.7 364.9 370.8C363.2 372.2 358.6 375.8 356.9 377.2C339.1 390.2 318.9 399.6 298.5 406.2C295 407.4 291.2 405.4 290 401.9C288.9 398.5 290.6 394.9 293.8 393.6C315.8 384.5 336 372.8 352.6 356.3C354.2 354.6 356.5 352.1 358.1 350.4C358.7 349.7 362.4 345 363.1 344.1C364.7 342 366.1 339.7 367.6 337.5C383.3 313 386 282.3 378.7 254.4C376.7 246.5 374.1 238.7 370.5 231.5C366.4 224.2 369 214.9 376.4 210.8C384.3 206.3 394.6 209.9 397.9 218.4Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_303068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacks);
export default __webpack_public_path__ + "static/media/Snacks.5f3cf481.svg";
export { ForwardRef as ReactComponent };